/**
 * The till's calendar day, as YYYY-MM-DD (2026-10-01).
 *
 * `new Date().toISOString().slice(0, 10)` is the UTC day, whatever the till's
 * clock says: from 7pm in Chicago it is already tomorrow. A till stands in the
 * store, so its own calendar day is the store's — the day a report file is
 * named for, a tax rate is live on, a waiver was signed.
 */
export function tillDay(at: Date = new Date()): string {
  const month = String(at.getMonth() + 1).padStart(2, '0');
  const day = String(at.getDate()).padStart(2, '0');
  return `${at.getFullYear()}-${month}-${day}`;
}
